import * as React from 'react';
import { ApplicationCopy } from '../../assets/ApplicationCopy';
import { inject, observer } from 'mobx-react';
import { ApplicationStore } from '../../data_layer/stores/ApplicationStore';
import {
    topNavBarContainer,
    titleContainer,
    logOutContainer,
    logOutLinkStyle,
} from '../../assets/styles/Layout/TopNavBar';
import { NavLinks } from './NavLinks';
import { RouteComponentProps } from 'react-router-dom';

interface Props extends RouteComponentProps<{}> {
    store?: ApplicationStore;
}

@inject('store')
@observer
export class TopNavBar extends React.Component<Props> {

    private logOut() {
        if (this.props.store) {
            this.props.store.authorizationStore.logout();
        }
    }

    render() {
        return (
            <div style={{ zIndex: 1000 }}>
                <div style={topNavBarContainer}>
                    <div style={titleContainer}>
                        {ApplicationCopy.applicationName}
                    </div>
                    <div style={logOutContainer}>
                        <a
                            href="#"
                            onClick={() => this.logOut()}
                            style={logOutLinkStyle}
                        >
                            LOG OUT
                        </a>
                    </div>
                </div>
                <NavLinks {...this.props} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/TopNavBar.tsx